<template>
    <div class="vx-col w-full mb-base">
        <vx-card title="Dados Básicos">
            <div class="vx-row">
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input class="w-full" label-placeholder="Nome Completo *" v-validate="'required|max:100'" name="nome" v-model="form.nome" />
                    <span class="text-danger">{{ errors.first('nome') }}</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input class="w-full" label-placeholder="CPF/CNPJ *" v-mask="['###.###.###-##', '##.###.###/####-##']" v-validate="{required: true}" name="cpf_cnpj" v-model="form.cpf_cnpj" />
                    <span class="text-danger text-sm">{{ errors.first('cpf_cnpj') }}</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input type="email" class="w-full" label-placeholder="Email *" v-validate="'required|email'" name="email" v-model="form.email" />
                    <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-1/6">
                    <vs-input class="w-full" label-placeholder="Data de Nascimento" v-mask="'##/##/####'" v-validate="{regex: '^([0-9\/]+)$' }" name="nascimento" v-model="form.data_nascimento" />
                    <span class="text-danger text-sm">{{ errors.first('data_nascimento') }}</span>
                </div>
                <div class="vx-col sm:w-1/6 w-full mb-2">
                    <vs-select v-model="form.sexo" name="sexo" label="Sexo" class="w-full">
                        <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in options1" />
                    </vs-select>
                </div>
                <div class="vx-col sm:w-1/6 w-full mb-2">
                    <vs-input class="w-full" label-placeholder="Celular" name="celular" v-mask="'(##)#####-####'" v-validate="{regex: '^\\([0-9]{2}\\)(9[0-9]{4}\-[0-9]{4})$' }" v-model="form.celular" />
                    <span class="text-danger text-sm">{{ errors.first('celular') }}</span>
                </div>
                <div class="vx-col sm:w-1/6 w-full mb-2">
                    <vs-input class="w-full" label-placeholder="Fixo" name="telefone" v-mask="'####-####'" v-validate="{regex: '^[2-8][0-9]{3}\-[0-9]{4}$' }" v-model="form.telefone" />
                    <span class="text-danger text-sm">{{ errors.first('telefone') }}</span>
                </div>
                <div class="vx-col sm:w-1/6 w-full mb-2">
                    <vs-input type="password" v-validate="'min:6|max:20'" ref="senha" class="w-full" label-placeholder="Nova Senha" name="senha" v-model="form.senha" />
                    <span class="text-danger text-sm">{{ errors.first('senha') }}</span>
                </div>
                <div class="vx-col sm:w-1/6 w-full mb-6">
                    <vs-input type="password" v-validate="'min:6|max:20|confirmed:senha'" class="w-full" label-placeholder="Repita a Senha" name="senha2" v-model="form.senha2" />
                    <span class="text-danger text-sm">{{ errors.first('senha2') }}</span>
                </div>
            </div>
        </vx-card>
        <vs-divider class="m-2"></vs-divider>
        <vx-card title="Endereço">
            <div class="vx-row">
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input class="w-full" label-placeholder="Logradouro" v-validate="'max:255'" name="end_rua" v-model="form.end_rua" />
                    <span class="text-danger">{{ errors.first('end_rua') }}</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input class="w-full" label-placeholder="Complemento" v-validate="'max:255'" name="end_complemento" v-model="form.end_complemento" />
                    <span class="text-danger text-sm">{{ errors.first('end_complemento') }}</span>
                </div>
                <div class="vx-col sm:w-1/6 w-full mb-2">
                    <vs-input class="w-full" label-placeholder="Número" v-validate="'max:7'" v-mask="'#######'" name="end_numero" v-model="form.end_numero" />
                    <span class="text-danger text-sm">{{ errors.first('end_numero') }}</span>
                </div>
                <div class="vx-col sm:w-1/6">
                    <vs-input class="w-full" label-placeholder="CEP" v-mask="'#####-###'" v-validate="{regex: '[\\d]{5}-[\\d]{3}' }" name="end_cep" @input="onCEP()" v-model="form.end_cep" />
                    <span class="text-danger text-sm">{{ errors.first('end_cep') }}</span>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input class="w-full" label-placeholder="Bairro" v-validate="'max:255'" name="end_bairro" v-model="form.end_bairro" />
                    <span class="text-danger">{{ errors.first('end_bairro') }}</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-select class="w-full" placeholder="Cidade" label="Cidade" label-placeholder="Cidade" autocomplete v-model="form.end_cidade" name="city">
                        <vs-select-item :key="index" v-for="(city, index) in getCities()" :text="city.nome" :value="city.nome"></vs-select-item>
                    </vs-select>
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-select class="w-full" placeholder="Estado" label="Estado" label-placeholder="Estado" autocomplete v-model="form.end_estado" name="region" @change="setCities">
                        <vs-select-item :key="index" v-for="(region, index) in getRegions()" :text="region.estado" :value="region.uf"></vs-select-item>
                    </vs-select>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col w-full">
                    <vs-button type="filled" @click.prevent="validate" class="mt-5 block">Salvar</vs-button>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import { moment } from "../helpers/moment";
    import { consultarCEP } from "../helpers/utils.js";

    export default {
        data() {
            return {
                form: {
                    nome: '',
                    cpf_cnpj: '',
                    email: '',
                    celular: '',
                    telefone: '',
                    data_nascimento: '',
                    senha: '',
                    senha2: '',
                    sexo: '',
                    end_rua: '',
                    end_complemento: '',
                    end_numero: '',
                    end_cep: '',
                    end_bairro: '',
                    end_cidade: '',
                    end_estado: '',
                },
                options1: [
                    {text: "Masculino", value: "m"},
                    {text: "Feminino", value: "f"},
                    {text: "Não informar", value: "nf"},
                ],
                cities: [
                    {id_cidade:0, nome: 'Cidade'}
                ],
                regions: [
                    {id_estado:0, estado: 'Estado'}
                ],
            }
        },
        async created() {
            await this.setRegions();
            if (this.form.end_estado) {
                this.setCities();
            }

            const {nome, cpf_cnpj, email, celular, telefone, data_nascimento, sexo, end_rua, end_complemento, end_numero, end_cep, end_bairro, end_cidade, end_estado } = this.currentUser;

            this.form = {
                nome,
                cpf_cnpj,
                email,
                celular,
                telefone,
                data_nascimento: moment(data_nascimento, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                senha: '',
                senha2: '',
                sexo,
                end_rua,
                end_complemento,
                end_numero,
                end_cep,
                end_bairro,
                end_cidade,
                end_estado,
            };
        },
        computed: {
            ...mapGetters(['currentUser'])
        },
        methods: {
            ...mapActions(['updateUser']),
            validate() {
                this.$validator.validateAll().then(result => {
                    if (result) this.send();
                })
            },
            send() {
                this.$axios.put(`saler`, this.form).then(({ data }) => {
                    this.updateUser({
                        ...this.currentUser,
                        ...data
                    });

                    this.$vs.notify({title: 'Sucesso', text: "Os dados foram atualizados!", color: "success", position: 'top-right', time: 5000});
                }).catch(({message}) => {
                    this.$vs.notify({title: 'Erro', text: `Ocorreu um erro ao realizar a atualização dos dados: ${message}.`, color: "danger", position: 'top-right', time: 5000});
                })
            },
            /**
             * Quando houver alterações no CEP, faz a consulta no viaCep
             */
            async onCEP() {
                const response = await consultarCEP(this.form.end_cep);

                if (response) {
                    this.form.end_numero = '';
                    this.form.end_rua = response.logradouro;
                    this.form.end_bairro = response.bairro;
                    this.form.end_cidade = response.localidade;
                    this.form.end_estado = response.uf;
                    this.form.end_complemento = response.complemento;
                }
            },
            async setRegions () {
                const { data } = await this.$axios.get("consulta/regions");
                this.regions = data;
            },
            getRegions () {
                return this.regions;
            },
            async setCities () {
                const region = this.regions.find(re => re.uf === this.form.end_estado);
                const { data } = await this.$axios.get(`consulta/regions/${region.id_estado}/cities`);
                this.cities = [
                    this.cities,
                    ...data
                ];
            },
            getCities () {
                return this.cities;
            }
        }
    }
</script>
